import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { LockOutlined, UserOutlined } from '@ant-design/icons';
import { Button, Checkbox, Form, Input, Typography, Flex } from 'antd';
import { Link, useNavigate } from "react-router-dom";
import api from '../service/axios'
import { useToasts } from 'react-toast-notifications';
import StringMask from "string-mask";
import { RecoilRoot, atom, selector, useRecoilState, useRecoilValue } from 'recoil';
import { userState } from '../service/database';
import { ref, set } from "firebase/database";
import { database } from '../service/meucrqce_firebase'
import { getAuth, signInWithEmailAndPassword, createUserWithEmailAndPassword } from "firebase/auth";
import pacote from '../../package.json'

import LOGORETANGULAR from '../images/logo-nova-retangular-branco.png'
import dayjs from 'dayjs';
import { isMobile } from 'react-device-detect';
import { responseMessage } from '../service/util'

const DELIMITERS = [".", "-", "/"];
const CNPJ_MASK = "00.000.000/0000-00";
const CPF_MASK = "000.000.000-00";

function removeTrailingCharIfFound(str, chars) {
    let result = str;

    chars.forEach(c => {
        if (str[str.length - 1] === c) {
            result = str.slice(0, str.length - 1);
        }
    });

    return result;
}

export const AreaRegistradoLogin = (props) => {

    let navigate = useNavigate()
    const [user, setUser] = useRecoilState(userState)
    const { addToast } = useToasts()
    const [cpfcnpj, setCpfCnpj] = useState("")// useState('00.114.325/0001-03'); //useState('07.546.953/0001-07')
    const [senha, setSenha] = useState("") // useState('6106')
    //   const [cpfcnpj, setCpfCnpj] = useState('043.014.193-90')  667.055.683-72   305772
    //   const [senha, setSenha] = useState('5050')
    const [loading, setLoading] = useState(false)
    const [email, setEmail] = useState('')

    useEffect(() => {
        //  console.log(user)
    }, [])

    function formatValue(str) {
        const unmaskedValue = str.replace(/[.\-\/]/g, "").trim();
        let mask = CPF_MASK;
        if (unmaskedValue.length > 11)
            mask = CNPJ_MASK;

        const formatted = StringMask.process(unmaskedValue, mask);
        return removeTrailingCharIfFound(formatted.result, DELIMITERS);
    }

    async function loginFirebase() {
        try {
            const auth = getAuth();
            signInWithEmailAndPassword(auth, email, senha)
                .then((userCredential) => {
                    // Signed in 
                    const user = userCredential.user;
                    // ...
                })
                .catch((error) => {
                    const errorCode = error.code;
                    const errorMessage = error.message;
                    addToast(errorMessage, { appearance: 'error', autoDismiss: true });
                });
        } catch (error) {
            addToast(error.message, { appearance: 'error', autoDismiss: true });
        }
    }

    async function consulta() {
        try {
            //console.log('teste')
            if (!cpfcnpj || !senha) {
                setUser(undefined)
                addToast("Informe todos os campos!", { appearance: 'error', autoDismiss: true });
                return
            }

            setLoading(true)
            const result = await api.post('/api/v1.0/registrado/login', { cpfcnpj: cpfcnpj, senha: senha })
            console.log(result.data)
            setUser(result.data)
            navigate("/registrado")

        } catch (erro) {
            addToast(responseMessage(erro.message), { appearance: 'error', autoDismiss: true });
        }
        setLoading(false)
    }

    return (<div style={{
        flexDirection: 'column',
        display: 'flex', justifyContent: 'center', alignItems: 'center', alignSelf: 'center',
        backgroundColor: '#2e4869', height: '100vh', maxHeight: '100vh'
    }}>

        <div style={{
            display: 'flex', flexDirection: 'column',
            alignItems: 'center', maxWidth: 500, width: isMobile ? 350 : 500, justifyContent: 'center', margin: 'auto'
        }}>
             <Flex vertical justify="center" align="center" style={{ padding: 5, marginTop: 5, marginBottom:10 }} >
                                    {/* <img height={50} alt="logor" src={LOGO} /> */}
                                    <span style={{ fontSize: '1.3em' }}><span style={{ color: '#07b15f' }}>MEU</span><strong style={{ color: 'white' }}>CRQCE</strong></span>
                                </Flex>
            <div style={{
                display: 'flex', flexDirection: 'column', backgroundColor: 'white',
                alignItems: 'center', justifyContent: 'center', margin: 'auto'
            }}>
                <div
                    name="normal_login2"
                    className="login-form"
                    style={{ margin: 25 }}>
                    <Flex justify='center' vertical align='center'>
                        <img style={{ width: 250, marginTop: 0 }}
                            alt='logo'
                            src={LOGORETANGULAR} />

                        {/* <Typography.Title level={4}>Área do Registrado</Typography.Title> */}
                    </Flex>



                    <div name="crqx" style={{ marginTop: 10, marginBottom: 15 }}>
                        {
                            <Input prefix={<UserOutlined className="site-form-item-icon" />}
                                placeholder="Informe o nº do CPF/CNPJ"
                                name='senha5'
                                autoComplete="off"
                                value={cpfcnpj}
                                onChange={(e) => setCpfCnpj(formatValue(e.target.value))} />
                        }
                        {/*
                    <Input prefix={<UserOutlined className="site-form-item-icon" />}
                        placeholder="Informe o seu e-mail"
                        name='senha5'
                        autoComplete="off"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)} />
                    */}
                    </div>
                    <div name="senha" style={{ marginTop: 10 }} >
                        <Input
                            prefix={<LockOutlined className="site-form-item-icon" />}
                            type="password"
                            value={senha}
                            placeholder="Informe a senha"
                            onChange={(e) => setSenha(e.target.value)}
                            onKeyUp={(e) => {
                                if (e.code === 'Enter')
                                    consulta()
                            }} />
                    </div>

                    <Button style={{ marginTop: 30 }}
                        type="primary"
                        block
                        loading={loading}
                        onClick={() => {
                            consulta()
                            //   loginFirebase()

                        }} className="login-form-button">
                        Acessar
                    </Button>

                    <Flex vertical>
                        <Flex justify='center'>
                            <Flex gap={50} style={{ fontSize: '0.9em', marginTop: 15 }}>

                                <Link to={"/forgot"} className="login-form-forgot" style={{ marginLeft: 5 }}>
                                    Primeiro acesso
                                </Link>

                                <Link to={"/forgot"} className="login-form-forgot" style={{ marginLeft: 5 }}>
                                    Esqueci a senha
                                </Link>
                            </Flex>
                        </Flex>
                    </Flex>

                    <Flex justify='center'>
                        <div style={{ fontSize: '0.9em', marginTop: 10 }}>
                            Ao clicar em <span style={{ fontWeight: 'bold' }}>Acessar</span> você aceita a nossa
                            <a href='http://crqx.org.br/politica-de-privacidade/' className="login-form-forgot" style={{ marginLeft: 5 }}>
                                Política de Privacidade
                            </a>
                        </div>
                    </Flex>

                    <Flex justify='center'>
                        <div style={{ fontSize: '0.8em', color: 'darkgray', marginTop: 15, fontStyle: 'italic' }}>
                            1983-{dayjs().format('YYYY')} (ver ) {pacote.version}
                        </div>
                    </Flex>

                </div>
            </div>
        </div>
    </div>
    );


}

const mapStateToProps = (state) => ({})

const mapDispatchToProps = {}

export default connect(mapStateToProps, mapDispatchToProps)(AreaRegistradoLogin)